import React, { useEffect, useRef } from "react";
import { useField } from "@unform/core";
import { FiAlertCircle } from "react-icons/fi";

import { Container, Error } from "./styles";

export default function Select({ name, ...rest }) {
  const inputRef = useRef(null);
  const { fieldName, registerField, error, defaultValue } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: "value",
    });
  }, [fieldName, registerField]);

  return (
    <Container isErrored={!!error} data-testid="input-container">
      <select ref={inputRef} defaultValue={defaultValue} {...rest} />
      {error && (
        <Error>
          <FiAlertCircle size={15} />
          <span>{error}</span>
        </Error>
      )}
    </Container>
  );
}
